import type { BillingPastSubscriptionAmountsResponseBodyType } from "@intelligems/ig-types/functions/billing-workflow/past-subscription-amounts";
import { billingModulesKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import type { QueryOptions } from "../../types/react-query";
import { api } from "../api";

export const getBillingPastSubscriptionAmounts =
  async (): Promise<BillingPastSubscriptionAmountsResponseBodyType> => {
    const resp = await api.get<BillingPastSubscriptionAmountsResponseBodyType>(
      "/v3/billing/past-subscription-amounts"
    );

    return resp.data;
  };

const PARTIAL_FAILURE_STALE_TIME_MS = 5 * 60 * 1000;

/**
 * What each ended subscription actually collected, read from its Stripe invoices.
 *
 * Deliberately a plain `useQuery` rather than a suspense query: this backs one column of
 * a collapsible table, so a slow or failing Stripe read must degrade that column rather
 * than suspend or blank the Billing page.
 */
export const useGetBillingPastSubscriptionAmounts = (
  orgId: string,
  options?: QueryOptions<BillingPastSubscriptionAmountsResponseBodyType, Error>
) =>
  useQuery<BillingPastSubscriptionAmountsResponseBodyType, Error>({
    retry: 1,
    staleTime: PARTIAL_FAILURE_STALE_TIME_MS,
    ...options,
    queryKey: billingModulesKeys.pastSubscriptionAmounts(orgId),
    queryFn: getBillingPastSubscriptionAmounts,
  });
